export enum IntegrationsQueryKeys {
  ListResources = 'integrations/listResources',
  ListResourceTypesFilterOptions = 'integrations/filterOptions/resourceTypes',
  ListTagsFilterOptions = 'integrations/filterOptions/tags',
  ListStatusesFilterOptions = 'integrations/filterOptions/statuses',
}
